<template>
  <v-col
    :class="{
      'get-lower': !$vuetify.breakpoint.mdAndUp,
      'pa-0': true,
      fullScreen: true,
      fullScreenMobile: this.$vuetify.breakpoint.mdAndDown
    }"
    cols="12"
  >
    <CommonDialog
      :dialog="dialogExport"
      :head-text="$t('buttons.export')"
      :confirm-button="{
        text: $t('buttons.export'),
        icon: 'mdi-download-outline'
      }"
      :on-cancel="() => (dialogExport = false)"
      :on-confirm="() => $refs['export'].exporting()"
    >
      <ExportRecordsMeterUnit
        ref="export"
        :meter-units="selected"
        :selected-meter-units="selected"
        :project_id="project_id"
        hide-button
      ></ExportRecordsMeterUnit>
    </CommonDialog>
    <CommonDialog
      :dialog="dialogDeleteRecords"
      :head-text="$t('meter-units.delete-records')"
      :confirm-button="{
        text: $t('contacts.delete'),
        icon: 'mdi-trash-can-outline'
      }"
      :on-cancel="() => (dialogDeleteRecords = false)"
      :on-confirm="() => $refs['delete-records'].save()"
    >
      <DeleteRecords
        class="delete-records"
        ref="delete-records"
        :success-callback="() => (dialogDeleteRecords = false)"
        :error-callback="() => (dialogDeleteRecords = false)"
        :meter-unit-list="selected"
        hide-save-button
        hide-text
        :meter-units="selected"
        :selected-meter-units="selected"
      ></DeleteRecords>
    </CommonDialog>
    <CommonDialog
      :dialog="dialogReprocessTransmissions"
      :head-text="$t('buttons.reprocess-transmissions')"
      :confirm-button="{
        text: $t('buttons.reprocess-transmissions'),
        icon: 'mdi-check'
      }"
      :on-cancel="() => (dialogReprocessTransmissions = false)"
      :on-confirm="() => $refs['reprocess'].reprocess()"
      :loading="loadingReprocessTransmissions"
    >
      <ReprocessTransmissionMeterUnit
        ref="reprocess"
        :meter-units="selected"
        :selected-meter-units="selected"
        :project_id="project_id"
        hide-button
        v-bind:loadingProp.sync="loadingReprocessTransmissions"
      ></ReprocessTransmissionMeterUnit>
    </CommonDialog>
    <CommonDialog
      :dialog="dialogRealignRecords"
      :head-text="$t('buttons.realign-records')"
      :confirm-button="{
        text: $t('buttons.realign-records'),
        icon: 'mdi-check'
      }"
      :on-cancel="() => (dialogRealignRecords = false)"
      :on-confirm="() => $refs['reprocess'].reprocess()"
      :loading="loadingRealignRecords"
    >
      <RealignRecords
        ref="reprocess"
        :meter-units="selected"
        :selected-meter-units="selected"
        :project_id="project_id"
        hide-button
        v-bind:loadingProp.sync="loadingRealignRecords"
      ></RealignRecords>
    </CommonDialog>
    <v-toolbar dense flat>
      <v-toolbar-title>{{ $t("meter-units.meter-units") }}</v-toolbar-title>
      <v-toolbar-items>
        <v-btn text color="primary" :to="{ name: 'new-meter-unit' }">
          <v-icon left>mdi-plus</v-icon>
          {{ $t("meter-units.create") }}
        </v-btn>
        <v-btn
          text
          color="primary"
          v-on:click="dialogDeleteRecords = true"
          :disabled="!selected.length"
        >
          <v-icon left>mdi-trash-can-outline</v-icon>
          {{ $t("meter-units.delete-records") }}
        </v-btn>
        <v-btn
          text
          color="primary"
          v-on:click="dialogExport = true"
          :disabled="!selected.length"
        >
          <v-icon left>mdi-download-outline</v-icon>
          {{ $t("buttons.export") }}
        </v-btn>
        <v-btn
          text
          color="primary"
          v-on:click="dialogReprocessTransmissions = true"
          :disabled="!selected.length"
        >
          <v-icon left>mdi-update</v-icon>
          {{ $t("buttons.reprocess-transmissions") }}
        </v-btn>
        <v-btn
          text
          color="primary"
          v-on:click="dialogRealignRecords = true"
          :disabled="!selected.length"
        >
          <v-icon left>mdi-update</v-icon>
          {{ $t("buttons.realign-records") }}
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-divider></v-divider>
    <v-col>
      <Search></Search>
    </v-col>
    <CommonTable
      list-getter="projectMeteringStore/meterUnitStore/getList"
      :headers="headers"
      :slots="slots"
      :actions="actions"
      resource="meter-units"
      deleteItemDispatch="projectMeteringStore/meterUnitStore/delete"
      createItemDispatch="projectMeteringStore/meterUnitStore/create"
      @updated="updateList"
      :loading.sync="loading"
      :selected.sync="selected"
      :static-dispatch-params="{ project_id: this.project_id }"
      show-select
    ></CommonTable>
    <Paginator
      page-getter="projectMeteringStore/meterUnitStore/getPage"
    ></Paginator>
  </v-col>
</template>

<script>
import Paginator from "../../../components/common/tables/Paginator";
import Search from "../../../components/common/tables/Search";
import CommonTable from "../../../components/common/tables/CommonTable";
import { rules } from "../../../components/mixins/rules";
import { projectTitle } from "../../../components/mixins/projects/projectTitle";
import CommonDialog from "../../../components/common/dialogs/CommonDialog";
import ExportRecordsMeterUnit from "../../../components/projects/metering/meter-units/ExportRecordsMeterUnit";
import DeleteRecords from "../../../components/projects/metering/manage-record/DeleteRecords";
import ReprocessTransmissionMeterUnit from "../../../components/projects/metering/meter-units/ReprocessTransmissionMeterUnit";
import RealignRecords from "../../../components/projects/metering/meter-units/RealignRecords";

export default {
  name: "MeterUnits",
  props: ["project_id"],
  mixins: [rules, projectTitle],
  components: {
    Paginator,
    Search,
    CommonTable,
    CommonDialog,
    ExportRecordsMeterUnit,
    DeleteRecords,
    ReprocessTransmissionMeterUnit,
    RealignRecords
  },
  data: function() {
    return {
      headers: [
        {
          text: this.$t("meter-units.name"),
          align: "left",
          value: "name"
        },
        {
          text: this.$t("meter-units.meter-path"),
          value: "path",
          sortable: false
        },
        {
          text: this.$t("meter-units.source"),
          value: "source_name",
          sortable: false
        },
        {
          text: this.$t("meter-units.ingestion"),
          value: "ingestion_name",
          sortable: false
        },
        {
          text: this.$t("meter-units.visualization"),
          value: "visualization_name",
          sortable: false
        }
      ],
      actions: [],
      slots: [
        {
          name: "name",
          type: "link",
          to: "meter-unit"
        },
        {
          name: "source_name",
          type: "link",
          to: "source",
          linkParams: {
            id: "source_id"
          }
        },
        {
          name: "ingestion_name",
          type: "link",
          to: "ingestion",
          linkParams: {
            id: "ingestion_id"
          }
        },
        {
          name: "visualization_name",
          type: "link",
          to: "visualization",
          linkParams: {
            id: "visualization_id"
          }
        },
        {
          name: "path",
          type: "groups",
          divider: " > "
        }
      ],
      loading: false,
      selected: [],
      dialogExport: false,
      dialogDeleteRecords: false,
      dialogReprocessTransmissions: false,
      dialogRealignRecords: false,
      loadingReprocessTransmissions: false,
      loadingRealignRecords: false
    };
  },
  computed: {
    getParams() {
      return ` ${this.$route.query.page}
                ${this.$route.query.limit_items}
                ${this.$route.query.orders}
                ${this.$route.query.search}
                `;
    },
    meterUnits() {
      return this.$store.getters["projectMeteringStore/meterUnitStore/getList"];
    }
  },

  watch: {
    getParams: function() {
      this.updateList();
    }
  },
  methods: {
    getArgumentForTitle() {
      return { chain: [this.$t("meter-units.meter-units")] };
    },
    updateList() {
      this.loading = true;
      let params = this.formingParams();
      this.$store.dispatch("projectMeteringStore/meterUnitStore/getList", {
        params,
        onSuccess: () => {
          this.loading = false;
        }
      });
    },
    formingParams() {
      return {
        project_id: this.project_id,
        page: this.$route.query.page,
        limit: this.$route.query.limit_items,
        orders: this.$route.query.orders,
        filters: {
          name: this.$route.query.search
        }
      };
    }
  },
  mounted() {
    this.updateList();
  }
};
</script>

<style scoped lang="scss">
.fullScreen {
  height: calc(100vh - 48px - 24px);
  display: flex;
  flex-direction: column;
}
.fullScreen::v-deep > * {
  flex: 0 0 auto;
}
.fullScreenMobile {
  height: auto;
  display: flex;
  flex-direction: column;
}
.delete-records::v-deep p {
  padding: 0 !important;
}
.delete-records::v-deep > div {
  padding: 0 !important;
}
</style>
